import Ajax from '../ajax';

export default {
  login: (data) => Ajax('post', 'login', data),
};
